"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReactiveMessage = void 0;
var rxjs_1 = require("rxjs");
var channels = new Map();
channels.set('default', new rxjs_1.Subject());
var getChannelMap = function () {
    if (typeof window !== 'undefined') {
        if (!window.AperzaReactiveMessageChannel) {
            window.AperzaReactiveMessageChannel = new Map();
            window.AperzaReactiveMessageChannel.set('default', new rxjs_1.Subject());
        }
        return window.AperzaReactiveMessageChannel;
    }
    else {
        return channels;
    }
};
var getChannel = function (channel) {
    if (channel === void 0) { channel = 'default'; }
    var channelMap = getChannelMap();
    if (channelMap) {
        if (channelMap.has(channel)) {
            return channelMap.get(channel);
        }
        else {
            console.warn("useReactiveMessage. Channel: " + channel + " is not found!");
        }
    }
    else {
        console.warn("useReactiveMessage. ChannelMap is not found!");
    }
};
var useReactiveMessage = function (channel) {
    if (channel === void 0) { channel = 'default'; }
    var c = getChannel(channel);
    if (!c) {
        var channelMap = getChannelMap();
        if (channelMap) {
            channelMap.set(channel, new rxjs_1.Subject());
        }
    }
    return {
        sendMessage: function (message, _channel) {
            var c = getChannel(_channel ? _channel : channel);
            if (c)
                c.next(__assign({}, message));
        },
        clearMessages: function (_channel) {
            var c = getChannel(_channel ? _channel : channel);
            if (c)
                c.next();
        },
        getMessage: function (_channel) {
            var c = getChannel(_channel ? _channel : channel);
            if (c)
                return c.asObservable();
        },
    };
};
exports.useReactiveMessage = useReactiveMessage;
//# sourceMappingURL=UseReactiveMessage.js.map